import {
  CreateButton, DeleteButton, EditButton, TextField, TopToolbar,
  useTranslate,
} from 'react-admin';
import { Datagrid } from '@react-admin/ra-rbac';
import { ListLive } from '@react-admin/ra-realtime';
import { LIST_DEBOUNCE } from '../../../config';
import SearchFields from '../components/fields/Filters';
import { TimeGranularityField } from '../../../components/fields/TimeGranularityField';
import ReferenceArrayFieldNullable from '../../../components/fields/ReferenceArrayFieldNullable';

export const InventoryCategoriesList = () => {

  const translate = useTranslate();

  return (
    <>
      <h3>{translate('resources.security_inventory_categories.title')}</h3>
      <p>{translate('resources.security_inventory_categories.text.sub_title')}</p>
      <ListLive filters={SearchFields} debounce={LIST_DEBOUNCE}
        actions={<TopToolbar><CreateButton label="general.text.add_from_presets" /></TopToolbar>}>
        <Datagrid rowClick={false} bulkActionButtons={false}>
          <TextField source="name" label="general.fields.name"/>
          <TimeGranularityField source="expiryInterval" label="resources.security_inventory_categories.fields.inspection_period"/>
          <ReferenceArrayFieldNullable source="peopleToNotify" reference="assets" label="resources.security_inventory_categories.fields.people_to_notify"/>
          <EditButton resource="security-inventory-categories"/>
          <DeleteButton resource="security-inventory-categories"/>
        </Datagrid>
      </ListLive>
    </>
  );

};
